import usePrivateAxios from '@/common/api/usePrivateAxios'
import { ErrorResponse } from '@/common/types/errorResponse'
import { useMutation, UseMutationOptions } from '@tanstack/react-query'

interface UseMaintenanceEstablishmentChoiceAuctionEntryFollowProps {
  auctionEntryId: string | undefined
  options?: Partial<Omit<UseMutationOptions<unknown, ErrorResponse>, 'mutationKey' | 'mutationFn'>>
}

export const useMaintenanceEstablishmentChoiceAuctionEntryFollow = ({
  auctionEntryId,
  options,
}: UseMaintenanceEstablishmentChoiceAuctionEntryFollowProps) => {
  const privateAxios = usePrivateAxios()

  return useMutation({
    mutationKey: ['maintenanceEstablishmentChoiceAuctionEntryFollow', auctionEntryId],
    mutationFn: () =>
      privateAxios.post(`/maintenance/establishment_choice/auction_entries/${auctionEntryId}/follow`),
    ...options,
  })
}
